import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c3e27c2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e27c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3e27c2')) {
      api.createRecord('3c3e27c2', component.options)
    } else {
      api.reload('3c3e27c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c3e27c2&scoped=true&", function () {
      api.rerender('3c3e27c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/index.vue"
export default component.exports